import { openFacebookShare, openTwitterShare, analyticsPushFunc, openLinkedinShare, openTelegramShare } from "../../../widgetsUtils"
import { CalcalistBodyCommercialButton } from "../../../../articlePage/stateInterfaces"
import { MailShareButton } from "../../../siteWidgets/socialShareButtons/mail/mailShareButton"
import { WhatsAppShareButton } from "../../../siteWidgets/socialShareButtons/whatsApp/whatsAppShareButton"
import { FrontCopyButton } from "../../../commonComponents/inline/frontCopyButton/frontCopyButton"

const siteArticleCommentsId = "SiteArticleComments"

interface CalcalistArticleActionsState {
    position: "top" | "bottom" | "fixed top" | "fixed bottom"
    pixelsFromLeft: number
}

interface CalcalistArticleActionsProps {
    articleTitle: string
    commercialBtn: CalcalistBodyCommercialButton
    commercialImgUrl: string
    showComments: boolean
    site?: string
    articleId?: string
}

interface CalcalistArticleActionsState{
    isDigitalMenuOpen:boolean
}

export class CalcalistArticleActions extends React.Component<CalcalistArticleActionsProps, CalcalistArticleActionsState> {
    public static siteScriptName = "CalcalistArticleActions";

    constructor() {
        super();
        this.state = {
            position: "top",
            pixelsFromLeft: 0,
             isDigitalMenuOpen: false
        }
    }

    private ulRef: HTMLElement

    componentDidMount() {
        addEventListener("scroll", _.throttle(this.onScroll, 20));
        window.addEventListener("resize", this.resetPosition, false)
        this.resetPosition();
    }
    componentWillUnmount() {
        // const navbar = document.getElementById("YnetHeader")
        document.removeEventListener("scroll", _.throttle(this.onScroll, 20))
        window.removeEventListener("resize", this.resetPosition, false)

    }
    /*
        componentDidUpdate() {
            this.resetPosition();
        }
    */
    private resetPosition = () => {
        if (!this.ulRef) return;
        const position = this.props.site === "ctech" ? this.ulRef.getBoundingClientRect().right : this.ulRef.getBoundingClientRect().left
        if (this.state.pixelsFromLeft !== position)
            this.setState({
                pixelsFromLeft: this.ulRef.getBoundingClientRect().left
            })
    }

    private onScroll = () => {
        if (!this.ulRef) return;
        const { position } = this.state;
        const articleBodyElement = document.getElementById("calcalistArticleComponenta");
        const articleBodyBoundingClientRect = articleBodyElement.getBoundingClientRect();
        const sideBarBoundingClientRect = this.ulRef.getBoundingClientRect();
        const sideposition = this.props.site === "ctech" ? this.ulRef.getBoundingClientRect().right : this.ulRef.getBoundingClientRect().left
        if (articleBodyBoundingClientRect.height <= sideBarBoundingClientRect.height) {
            return;
        }

        switch (position) {
            case "top":
                if (articleBodyElement.getBoundingClientRect().top < 0) {
                    this.setState({
                        position: "fixed top",
                        pixelsFromLeft: this.ulRef.getBoundingClientRect().left
                    })
                }
                break;

            case "fixed top":
                if (articleBodyElement.getBoundingClientRect().bottom < this.ulRef.getBoundingClientRect().bottom) {
                    this.setState({
                        position: "bottom",
                        pixelsFromLeft: this.ulRef.getBoundingClientRect().left
                    })
                }
                if (articleBodyElement.getBoundingClientRect().top > this.ulRef.getBoundingClientRect().top) {
                    this.setState({
                        position: "top",
                        pixelsFromLeft: this.ulRef.getBoundingClientRect().left
                    })
                }
                break;

            case "bottom":
                if (this.ulRef.getBoundingClientRect().top > 0) {
                    this.setState({
                        position: "fixed top"
                    })
                }
                break;

        }
    }

    private getStyle = () => {
        const { position, pixelsFromLeft } = this.state;

        let style;
        // let positionLoR = this.props.site === "ctech" ? {  } : { left: pixelsFromLeft }
        let basicePosition = { left: "40px", right: "auto" }
        if (position == "fixed top") {
            style = {
                left: pixelsFromLeft,
                marginTop: "20px",
                marginBottom: 0,
                position: "fixed",
                top: "0px"
            }
        }

        if (position == "fixed bottom") {
            style = {
                left: pixelsFromLeft,
                marginTop: "20px",
                marginBottom: 0,
                position: "fixed",
                bottom: "0px"
            }
        }

        if (position == "top") {
            style = {
                top: "0px",
                ...basicePosition,
                bottom: "auto",
            }
        }

        if (position == "bottom") {
            style = {
                top: "auto",
                ...basicePosition,
                bottom: "0px",
            }
        }

        return style;
    }

    private printArticle = () => {
        if (typeof window != "undefined") {
            window.print();
        }
    }

    private handleShareBtnClicked = (button: string, lang: string) => {
        if (typeof window !== "undefined") {
            const current_url = window.location.href;
            const { articleTitle } = this.props
            switch (button) {
                case "fb":
                    openFacebookShare(current_url, "", () => analyticsPushFunc("Facebook", "Article Side", articleTitle), "Article Side")
                    break;
                case "tw":
                    openTwitterShare(current_url, () => analyticsPushFunc("Twitter", "Article Side", articleTitle), "Article Side")
                    break;
                case "ld":
                    openLinkedinShare(current_url, () => analyticsPushFunc("Linkedin", "Article Side", articleTitle))
                    break;
                case "wa":
                    WhatsAppShareButton.openWhatsAppShare(current_url, () => analyticsPushFunc("Whatsapp", "Article Top", articleTitle), "Article Top")
                    break;
                case "mailto":
                    MailShareButton.openMailShare(articleTitle, current_url, lang, () => analyticsPushFunc("Mail", "Article Side", articleTitle), "Article Side")
                    break;
            }
        }
    }

    private isTalkbackElement = () => {
        if (typeof window !== 'undefined') {
            return !!document.getElementById(siteArticleCommentsId);
        }
    }

    private scrollTalkbacksIntoView = (e) => {
        document.getElementById(siteArticleCommentsId).scrollIntoView({ behavior: "smooth" }); // true = align to top        
    }


    private handleDigitalPopupVisability =(isDigitalMenuOpen) =>{
     if (isDigitalMenuOpen) this.setState({ isDigitalMenuOpen: false }) ;
     else{
        this.setState({ isDigitalMenuOpen: true }) 
     }
    }

    public render() {
        const lang = this.props.site === "ctech" ? "enCtech" : "heCalcalist";
        const { commercialBtn, commercialImgUrl, showComments, articleId } = this.props
        const { isDigitalMenuOpen }= this.state 
        const copy_url_link = typeof window === "undefined" ? "https://calcalist.co.il" : window.location.origin + window.location.pathname;
        const _showComments = showComments || this.isTalkbackElement();
        const showDigital = isDigitalMenuOpen ? "opened" : ""; 
    

        return (
            <div className="art-action-wrp">
                {this.props.site === "ctech" &&
                <ul className="art-action" data-articleid="3763857" ref={ref => this.ulRef = ref} style={this.getStyle()}>
                    {_showComments && this.props.site !== "ctech" && <li title="Talkback" className="share-icon talkback" onClick={this.scrollTalkbacksIntoView}></li>}
                    <li title="Email" className="share-icon email" onClick={e => this.handleShareBtnClicked("mailto", lang)}></li>
                    <li title="Whatsapp" className="share-icon whatsapp" onClick={(e) => this.handleShareBtnClicked("wa", lang)} />
                    <li title="Facebook" className="share-icon facebook" onClick={(e) => this.handleShareBtnClicked("fb", lang)} />
                    <li title="Twitter" className="share-icon twitter" onClick={(e) => this.handleShareBtnClicked("tw", lang)} />
                    <li title="Print" className="share-icon print" onClick={this.printArticle} />
                    {this.props.site === "ctech" && <li title="Linkedin" className="share-icon linkedin" onClick={(e) => this.handleShareBtnClicked("ld", lang)} />}
                     {commercialBtn.enable &&<li style={{ backgroundImage: `url(${commercialImgUrl})` }} title={commercialBtn.linkProperties.link.description} className="CommercialLink" aria-label="מודעה">
                        <a target="_blank" href={commercialBtn.linkProperties.link.publishedLink} style={{ height: "100%", width: "100%", display: "block" }} />
                    </li>}
                </ul>
               }
               {this.props.site !== "ctech" &&
                <ul className={`art-action ${_showComments ? "withComments" : "noComments"}`} data-articleid="3763857" ref={ref => this.ulRef = ref} style={this.getStyle()}>
                    {_showComments && this.props.site !== "ctech" && <li title="תגובות" className="share-icon talkback" onClick={this.scrollTalkbacksIntoView}></li>}                 
                    <FrontCopyButton
                            popupText="הקישור הועתק ללוח"
                            classes="share-icon copy"
                            url={`${copy_url_link}?utm_source="calcalist.co.il&utm_medium=Share&utm_campaign=copy_url#${articleId}`}
                    />  
                    <div className="share-icon" onClick={()=>this.handleDigitalPopupVisability(isDigitalMenuOpen)}>              
                    <li title="כלכליסט דיגיטל" className="share-icon digital" />
                    <li className="digitalText">כלכליסט דיגיטל</li>
                    </div>
                     {commercialBtn.enable && <li style={{ backgroundImage: `url(${commercialImgUrl})` }} title={commercialBtn.linkProperties.link.description} className="CommercialLink" aria-label="מודעה">
                        <a target="_blank" href={commercialBtn.linkProperties.link.publishedLink} style={{ height: "100%", width: "100%", display: "block" }} />
                    </li>}
                    {showDigital && 
                    <div className={`digitalShare ${showDigital}`}>
                        <ul className="art-action-digital" data-articleid="3763857" ref={ref => this.ulRef = ref} >
                            <li title="Facebook" className="share-icon facebook"><a href="https://www.facebook.com/calcalistonline" target="_blank"></a></li>
                            <li title="Twitter" className="share-icon twitter"><a href="https://x.com/calcalist" target="_blank"></a></li>
                            <li title="Telegram" className="share-icon telegram"><a href="  https://t.me/calcalist" target="_blank"></a></li>
                            <li title="Email" className="share-icon email"><a href="https://www.calcalist.co.il/newsletter"></a></li>
                            <li title="Podcast" className="share-icon podcast"><a href="https://www.calcalist.co.il/podcast"></a></li>
                            <li title="Tv" className="share-icon tv"><a href="https://www.calcalist.co.il/tv"></a></li>
                        </ul>
                    </div>
                    }                 
                </ul>
                }
            </div>
        )
    }
}